import { LOCALE_ID, NgModule } from '@angular/core';
import localeEsCO from '@angular/common/locales/es-CO';
import { CommonModule, registerLocaleData } from '@angular/common';
import { CotizadorComponent } from './pages/cotizador/cotizador.component';
import { NewFlowRoutingModule } from './newflow-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from "@app/components/components.module";
import { StepperComponent } from "@app/tenant/components/stepper/stepper.component";
import { SharedModule } from "@app/shared/shared.module";
import { NewFlowBannerComponent } from './components/new-flow-banner/new-flowbanner.component';
import { NewStepperComponent } from "./components/new-stepper/newstepper.component";
import { NewFinFlujoComponent } from "./pages/new-fin-flujo/new-fin-flujo.component" 
import { NewPlanesSegurosComponent } from './pages/new-planes-seguros/new-planes-seguros.component';
import { NgbProgressbar } from "@ng-bootstrap/ng-bootstrap";
import { TextoPrincipalPlanesComponent } from './components/texto-principal-planes/texto-principal-planes.component';
import { NewArmarPlanComponent } from './pages/new-armar-plan/new-armar-plan.component';
import { NewDatosInquilinoComponent } from './pages/new-datos-inquilino/new-datos-inquilino.component';
import { NewInmuebleComponent } from './pages/new-inmueble/new-inmueble.component';
import { NewDatosPropietarioComponent } from './pages/new-datos-propietario/new-datos-propietario.component';
import { CotizacionPausaComponent } from './pages/fin-flujo/cotizacion-pausa/cotizacion-pausa.component';
import { OtroProductoComponent } from './pages/fin-flujo/otro-producto/otro-producto.component';
import { ProblemasTecnicosComponent } from './pages/fin-flujo/problemas-tecnicos/problemas-tecnicos.component';
import { LoSentimosComponent } from './pages/fin-flujo/lo-sentimos/lo-sentimos.component';
import { NoCumplePoliticasComponent } from './pages/fin-flujo/no-cumple-politicas/no-cumple-politicas.component';
import { PolizaActivaComponent } from './pages/fin-flujo/poliza-activa/poliza-activa.component';
import { TenemosTusDatosComponent } from './pages/fin-flujo/tenemos-tus-datos/tenemos-tus-datos.component';
import { LoaderComponent } from './pages/new-loader/new-loader.component';

import { generalReducer } from 'src/storage/general.reducer';
import { StoreModule } from '@ngrx/store';
import { metaReducers } from 'src/storage/meta-reducers';
import { EffectsModule } from '@ngrx/effects';
import { GeneralEffects } from 'src/storage/general.effects';
import { AquiEstaremosComponent } from './pages/fin-flujo/aqui-estaremos/aqui-estaremos.component';
import { CotizacionPausaInactivoComponent } from './pages/fin-flujo/cotizacion-pausa-inactivo/cotizacion-pausa-inactivo.component';
import { ValidacionErrorComponent } from './pages/fin-flujo/validacion-error/validacion-error.component';
import { AdvisorFormComponent } from '@app/shared/components/advisor-form/advisor-form.component';
import { HelpToCallComponent } from './components/help-to-call/help-to-call.component';
import { RetomaDuplicadoComponent } from './pages/fin-flujo/retoma-duplicado/retoma-duplicado.component';
import { NewDatosInquilinoProcesoComponent } from './pages/new-datos-inquilino-proceso/new-datos-inquilino-proceso.component';
import { CheckTheInformationComponent } from './pages/fin-flujo/check-the-information/check-the-information.component';
import { SarlaftDeniedComponent } from './pages/fin-flujo/sarlaft-denied/sarlaft-denied.component';
import { ResumenCompraP2PComponent } from './pages/pago/resumen-compra-p2p/resumen-compra-p2p.component';
import { ProcesandoPagoComponent } from './pages/pago/procesando-pago/procesando-pago.component';
import { PagoAprobadoComponent } from './pages/pago/pago-aprobado/pago-aprobado.component';
import { PagoAprobadoNoApComponent } from './pages/pago/pago-aprobado-no-ap/pago-aprobado-no-ap.component';
import { PagoRechazadoP2PComponent } from './pages/pago/pago-rechazado-p2p/pago-rechazado-p2p.component';
import { SummaryPlanCardComponent } from './components/summary-plan-card/summary-plan-card.component';
import { SubscriptionCardComponent } from './components/subscription-card/subscription-card.component';
import { ManualPaymentCardComponent } from './components/manual-payment-card/manual-payment-card.component';
import { PolicyStartDateComponent } from './components/policy-start-date/policy-start-date.component';
import { SuraLoaderComponent } from './components/sura-loader/sura-loader.component';

registerLocaleData(localeEsCO, 'es-CO');

@NgModule({
  declarations: [
    CotizadorComponent,
    NewFlowBannerComponent,
    NewDatosPropietarioComponent,
    NewDatosInquilinoProcesoComponent,
    NewInmuebleComponent,
    NewFinFlujoComponent,
    NewArmarPlanComponent,
    NewPlanesSegurosComponent,
    TextoPrincipalPlanesComponent,
    CotizacionPausaComponent,
    OtroProductoComponent,
    NewDatosInquilinoComponent,
    ProblemasTecnicosComponent,
    LoSentimosComponent,
    NoCumplePoliticasComponent,
    PolizaActivaComponent,
    TenemosTusDatosComponent,
    LoaderComponent,
    AquiEstaremosComponent,
    CotizacionPausaInactivoComponent,
    ValidacionErrorComponent,
    RetomaDuplicadoComponent,
    CheckTheInformationComponent,
    SarlaftDeniedComponent,
    ResumenCompraP2PComponent,
    ProcesandoPagoComponent,
    PagoAprobadoComponent,
    PagoAprobadoNoApComponent,
    PagoRechazadoP2PComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NewFlowRoutingModule,
    AdvisorFormComponent,
    HelpToCallComponent,

    
    ComponentsModule,
    StepperComponent,
    SharedModule,
    NewStepperComponent,
    NgbProgressbar,
    SummaryPlanCardComponent,
    SubscriptionCardComponent,
    ManualPaymentCardComponent,
    PolicyStartDateComponent,
    SuraLoaderComponent,
    StoreModule.forFeature('general', generalReducer, { metaReducers }),
        EffectsModule.forFeature([GeneralEffects]),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-CO' } // 👈 Fijar locale global
  ],
exports:[NewDatosInquilinoComponent]
})
export class NewFlowModule { }
